

import { configs } from '../configs/configs';
import environments from '../configs/environments';

const ELIGIBILITY_RECEIVED = 'ELIGIBILITY_RECEIVED';
const OPEN ='OPEN';
const UNCLAIMED = 'UNCLAIMED';
const OP = 'OP';
const ER = 'ER';
const UC = 'UC';

const statusConstants = {
    [environments.CUSTOM]: {
        ELIGIBILITY_RECEIVED: ER,
        OPEN: OP,
        UNCLAIMED: UC
    },
    [environments.PRODUCTION]: {
        ELIGIBILITY_RECEIVED,
        OPEN,
        UNCLAIMED
    },
    [environments.DEVELOPMENT]: {
        ELIGIBILITY_RECEIVED,
        OPEN,
        UNCLAIMED
    }
};

export const APPLICATION_STATUSES = statusConstants[configs.mode];
